export const SUBSCRIBE_DEVICE_REQUEST = 'SUBSCRIBE_DEVICE_REQUEST';
export const SUBSCRIBE_DEVICE_SUCCESS = 'SUBSCRIBE_DEVICE_SUCCESS';
export const SUBSCRIBE_DEVICE_FAILURE = 'SUBSCRIBE_DEVICE_FAILURE';
export const UNSUBSCRIBE_DEVICE_ACTION = 'UNSUBSCRIBE_DEVICE_ACTION';


export const subscribeDeviceRequestAction = () => ({
  type: SUBSCRIBE_DEVICE_REQUEST,
});

export const subscribeDeviceSuccessAction = (data: any) => ({
  type: SUBSCRIBE_DEVICE_SUCCESS,
  payload: data,
});

export const subscribeDeviceFailureAction = (error: Error) => ({
  type: SUBSCRIBE_DEVICE_FAILURE,
  payload: error,
});

export const unsubscribeDeviceAction = () => ({
  type: UNSUBSCRIBE_DEVICE_ACTION,
});